// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"7337":"ad2866b8","8445":"bc98253f"}[chunkId] || chunkId) + "." + {"124":"fbee6df9a975e26c","1838":"35a10cf056021bfa","7337":"f12cbd5b8552944b","8445":"787bc7fb6d53cc21"}[chunkId] + ".js";
};